import type {
  CreateExportJobRequest,
  CreateImportJobRequest,
  CreateImportJobResponse,
  ExportJob,
  FieldMapping,
  ImportJob,
} from "@sales-ops-amplify/shared";
import { apiGet, apiPost, apiPut } from "./client";

export function createImportJob(
  body: CreateImportJobRequest & { csvText?: string },
): Promise<CreateImportJobResponse> {
  return apiPost("/api/data-exchange/imports", body);
}

export function saveImportMapping(
  jobId: string,
  mapping: FieldMapping,
): Promise<{ job: ImportJob }> {
  return apiPut(
    `/api/data-exchange/imports/${encodeURIComponent(jobId)}/mapping`,
    mapping,
  );
}

export function startImportJob(jobId: string): Promise<{ job: ImportJob }> {
  return apiPost(`/api/data-exchange/imports/${encodeURIComponent(jobId)}/start`, {});
}

export function listImportJobs(): Promise<{ jobs: ImportJob[] }> {
  return apiGet("/api/data-exchange/imports");
}

export function getImportJob(jobId: string): Promise<{ job: ImportJob }> {
  return apiGet(`/api/data-exchange/imports/${encodeURIComponent(jobId)}`);
}

export function getImportErrorsUrl(jobId: string): Promise<{ url: string }> {
  return apiGet(`/api/data-exchange/imports/${encodeURIComponent(jobId)}/errors`);
}

export function createExportJob(
  body: CreateExportJobRequest,
): Promise<{ job: ExportJob; downloadUrl?: string }> {
  return apiPost("/api/data-exchange/exports", body);
}

export function listExportJobs(): Promise<{ jobs: ExportJob[] }> {
  return apiGet("/api/data-exchange/exports");
}
